export class ThreatHuntingScanRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "threatHuntingType",
            "baseName": "threatHuntingType",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ThreatHuntingStatus",
            "format": ""
        },
        {
            "name": "requestedAt",
            "baseName": "requestedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastRunAt",
            "baseName": "lastRunAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "completedAt",
            "baseName": "completedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "estimatedScanRun",
            "baseName": "estimatedScanRun",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "failureReason",
            "baseName": "failureReason",
            "type": "string",
            "format": ""
        },
        {
            "name": "fulfillingSnapshotId",
            "baseName": "fulfillingSnapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "scannedFiles",
            "baseName": "scannedFiles",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "skippedFiles",
            "baseName": "skippedFiles",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "totalMatches",
            "baseName": "totalMatches",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "truncated",
            "baseName": "truncated",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "scanDurationSeconds",
            "baseName": "scanDurationSeconds",
            "type": "number",
            "format": "double"
        },
        {
            "name": "scanMode",
            "baseName": "scanMode",
            "type": "string",
            "format": ""
        },
        {
            "name": "yaraXVersion",
            "baseName": "yaraXVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "forgeVersion",
            "baseName": "forgeVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "forgeRuleCount",
            "baseName": "forgeRuleCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "customRuleCount",
            "baseName": "customRuleCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "createdByUserId",
            "baseName": "createdByUserId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ThreatHuntingScanRequest.attributeTypeMap;
    }
    constructor() {
    }
}
